import type { ReactNode } from 'react';

export const replaceStringWithComponent = (text: string, pattern: { keyword: string; value: ReactNode }) => {
  if (!text) {
    return;
  }

  if (!pattern || text.search(pattern.keyword) === -1) {
    return text;
  }

  return (
    <>
      {text
        .split(pattern.keyword)
        .reduce(
          (
            previousValue: (ReactNode | string)[],
            currentValue: ReactNode | string,
            currentIndex: number,
          ): ReactNode[] => {
            if (!currentIndex) {
              return [currentValue];
            }
            return previousValue.concat(pattern.value, currentValue);
          },
          [],
        )}
    </>
  );
};
